import React, { Component } from 'react';

export default class NotTalkUser extends Component {
  render() {

    return (
      <div id="kakaoContent" className="cont_bridge" role="main">
        <span className="img_404" />
        <strong className="tit_bridge">이 계정과 연결된 카카오톡이 없습니다.</strong>
        <p className="desc_bridge">모바일 카카오톡에 연결된 카카오계정을<br />확인한 후 다시 시도해주세요.</p>
        <div className="logout_bridge">
          <a href={`${process.env.REACT_APP_KAKAO_ACCOUNT_URL}/logout?continue=${process.env.REACT_APP_SERVICE_HOST}/logged_out`}
            className="link_logout logout" data-tiara-layer="logout"
          >
            로그아웃
          </a>
        </div>
			</div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/ErrorContent/NotTalkUser.js